























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { BabysitterReport } from '@/interfaces/Models';

@Component
export default class BabysitterReportForm extends Vue {

    @Prop() dialog!: boolean;
    @Prop() resource!: any | null;

    public disabled: boolean = false;
    public errors: any = {};

    public processing: boolean = false;

    public babysitterReport: BabysitterReport = {
        id: 0,
        babysitting_session_report_id: 0,
        rating: 3,
        note: ''
    }

    public ratingSettings: any = [
        {
            icon: 'mdi-emoticon-dead-outline',
            color: 'red',
        },
        {
            icon: 'mdi-emoticon-sad-outline',
            color: 'red',
        },
        {
            icon: 'mdi-emoticon-neutral-outline',
            color: 'yellow darken-1',
        },
        {
            icon: 'mdi-emoticon-happy-outline',
            color: 'green lighten-2',
        },
        {
            icon: 'mdi-emoticon-excited-outline',
            color: 'green',
        },
    ];
    
    public get resourceIsSet(): boolean {
        if ( this.babysitterReport.id > 0 ) {
            return true;
        }
        return false;
    }

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }
    
    public close() {
        this.errors = {};
        /* this.$refs.form.reset(); */
        this.$emit('update:dialog', !this.dialog);
    }

    public save() {

        this.processing = true;

        let path = api.path('v1.p.babysitterReports');
        
        let payload = {
            ...this.babysitterReport,
            babysitting_session_report_id: this.resource.id,
        }
        
        axios.post(path, payload)
            .then(res => {
                this.$toast.success(res.data.message);
                this.resource.babysitter_report = { ...this.babysitterReport, id: res.data.data.id };
                this.disabled = true;
                this.close();
            })
            .catch((error) => this.errors = error.response.data.errors)
            .finally(() => this.processing = false);
    }

    
    @Watch('resource')
    onResourceChange(babysittingSessionReport: any) {

        this.disabled = false;

        this.babysitterReport = { ...babysittingSessionReport?.babysitter_report };

        if ( babysittingSessionReport?.babysitter_report != null ) {
            this.disabled = true;
        } else {
            this.babysitterReport.rating = 3;
        }
        
    }
}
